import { combineReducers } from 'redux';
import App from './app';

const Reducers = () => combineReducers({
    app: App,
});

export default Reducers;
